import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Regions/hooks/useRegion.ts
function useRegion(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Regions.GetRegionProfile.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args?.regionId
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useRegion };

//# sourceMappingURL=useRegion.js.map